export const ANNOTATION_OTHER_BUBBLE_BG = "#f5f5f5";

export const ANNOTATION_OTHER_TEXT_COLOR = "#111827";

export const ANNOTATION_USER_NAME_COLORS = [
  "#FF1744",
  "#F50057",
  "#D500F9",
  "#651FFF",
  "#5C6BC0",
  "#1E88E5",
  "#039BE5",
  "#00897B",
  "#00C853",
  "#64DD17",
  "#AEEA00",
  "#FFAB00",
  "#FF6D00",
  "#827717",
  "#FF4081",
  "#673AB7",
  "#00ACC1",
  "#E91E63",
];

const hexToRgb = (hex) => {
  const value = hex.replace("#", "");

  return {
    r: parseInt(value.substring(0, 2), 16),
    g: parseInt(value.substring(2, 4), 16),
    b: parseInt(value.substring(4, 6), 16),
  };
};

const rgba = (hex, alpha) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const createAnnotationUserColor = ({ nameColor }) => ({
  bubble: ANNOTATION_OTHER_BUBBLE_BG,
  name: nameColor,
  text: ANNOTATION_OTHER_TEXT_COLOR,
  fileRow: {
    background: rgba(ANNOTATION_OTHER_TEXT_COLOR, 0.06),
    backgroundHover: rgba(ANNOTATION_OTHER_TEXT_COLOR, 0.1),
    border: rgba(ANNOTATION_OTHER_TEXT_COLOR, 0.14),
    text: ANNOTATION_OTHER_TEXT_COLOR,
    icon: ANNOTATION_OTHER_TEXT_COLOR,
  },
});

const getStablePaletteIndex = ({ userID }) => {
  if (!userID) return 0;

  let hash = 0;
  const value = String(userID);

  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash) % ANNOTATION_USER_NAME_COLORS.length;
};

const getNextAvailablePaletteIndex = ({ usedIndices }) =>
  ANNOTATION_USER_NAME_COLORS.findIndex((_, index) => !usedIndices.has(index));

export const getAnnotationUserColor = ({ userID }) =>
  createAnnotationUserColor({
    nameColor: ANNOTATION_USER_NAME_COLORS[getStablePaletteIndex({ userID })],
  });

export const buildAnnotationUserColorMap = ({
  annotations = [],
  currentOwnerUid,
}) => {
  const colorMap = {};
  const usedIndices = new Set();
  const otherUserIDs = [];

  for (const annotation of annotations) {
    const userID = annotation?.userID;
    if (!userID || userID === currentOwnerUid) continue;

    if (!otherUserIDs.includes(userID)) {
      otherUserIDs.push(userID);
    }
  }

  for (const userID of otherUserIDs) {
    let paletteIndex = getStablePaletteIndex({ userID });

    if (usedIndices.has(paletteIndex)) {
      paletteIndex = getNextAvailablePaletteIndex({ usedIndices });
    }

    if (paletteIndex === -1) {
      paletteIndex = getStablePaletteIndex({ userID });
    } else {
      usedIndices.add(paletteIndex);
    }

    colorMap[userID] = createAnnotationUserColor({
      nameColor: ANNOTATION_USER_NAME_COLORS[paletteIndex],
    });
  }

  return colorMap;
};
